'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _package = { version: '2.10.1' };

exports["default"] = _package.version;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/version/index.js
// module id = 588
// module chunks = 0